export default __webpack_public_path__ + "static/media/dwarf-498.fb7906fd.mp3";